import createStore from './createStore';

export const { store, persistor } = createStore();
